export const getTopsortProductId = ({
  id,
  url
}: {
  id: string | number;
  url?: string;
}): string => {
  const isBileto = typeof url === 'string' && url.includes('bileto');

  if (!isBileto) {
    return String(id);
  }

  const biletoId = url.match(/\/event\/(\d+)/)?.[1];

  return biletoId || String(id);
};
